import { render } from "./ModalFone.vue?vue&type=template&id=1da6d492&scoped=true"
import script from "./ModalFone.vue?vue&type=script&lang=js"
export * from "./ModalFone.vue?vue&type=script&lang=js"

import "./ModalFone.vue?vue&type=style&index=0&id=1da6d492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da6d492"]])

export default __exports__